// ── Placeholder stock ────────────────────────────────────────────────────────────
// "No Connected Model" is the catch-all stock for platform listings that have no real
// stock behind them (ERP-5128). It is the one stock that many listings legitimately
// share, which makes it the exception to two rules:
//   • Add/Edit Listing lets it through the "stock is already listed" check.
//   • The Platform Listing and Platform Pricing tables group listings by stock; each
//     listing on this stock stays a row of its own instead of being tied to the rest.
const PLACEHOLDER_STOCK_NAME = 'no connected model';
const PLACEHOLDER_SKU_NAME = 'no connected sku';

const norm = v => (v || '').trim().toLowerCase();

// Takes the SPU and SKU names as the API returns them (spu_name / sku_name).
export const isPlaceholderStock = (spuName, skuName) =>
    norm(spuName) === PLACEHOLDER_STOCK_NAME || norm(skuName) === PLACEHOLDER_SKU_NAME;
